import { writable } from 'svelte/store';
import { browser } from '$app/environment';

export const ordersCount = writable(null);

export async function fetchOrdersCount(email = '') {
  if (!browser || !email) return;
  try {
    const query = email ? `?email=${encodeURIComponent(email)}` : '';
    const res = await fetch(`/api/orders/count${query}`);
    if (res.ok) {
      const data = await res.json();
      ordersCount.set(data.count ?? 0);
    }
  } catch (e) {
    console.error('Failed to fetch orders count:', e);
  }
}
